/* Blissy Black Friday layer. Loaded (deferred) only while Theme settings > Black Friday is on. */
(() => {
  /* Offer countdown: one per visitor, Theme settings > Black Friday > Offer countdown length long. The start
     time is stored so every page shows the same time left; when it reaches zero a new countdown starts. */
  const countdowns = document.querySelectorAll('[data-bf-countdown]');
  if (countdowns.length) {
    const length = (Number(countdowns[0].getAttribute('data-bf-countdown')) || 3) * 3600000;
    const key = 'bf-offer-countdown';
    let start = 0;
    try { start = Number(localStorage.getItem(key)) || 0; } catch (error) { /* storage unavailable: count from this page */ }
    const save = () => { try { localStorage.setItem(key, String(start)); } catch (error) { /* storage unavailable */ } };
    if (!start || start > Date.now()) { start = Date.now(); save(); }
    const pad = (value) => String(value).padStart(2, '0');
    const tick = () => {
      if (Date.now() - start >= length) { start += Math.floor((Date.now() - start) / length) * length; save(); }
      const total = Math.ceil((length - (Date.now() - start)) / 1000);
      const parts = { h: Math.floor(total / 3600), m: Math.floor((total % 3600) / 60), s: total % 60 };
      countdowns.forEach((countdown) => {
        countdown.querySelectorAll('[data-unit]').forEach((unit) => { unit.querySelector('b').textContent = pad(parts[unit.dataset.unit]); });
        countdown.hidden = false;
      });
    };
    tick();
    setInterval(tick, 1000);
  }
})();
